export type EligibilityData = {
  game_played: boolean;
  have_not_redeemed_this_period: boolean;
  social_link: boolean;
};

type EligibilityRule =
  | "have_linked_any_social_media"
  | "have_verified_phone"
  | "is_not_sybil"
  | "is_not_sanctioned"
  | "is_kyc_exempt"
  | "has_valuable_key";

export interface EligibilityResponse {
  is_eligible: boolean;
  rules: Record<EligibilityRule, boolean>;
  kyc_link?: string;
}

export type EarningResponse = {
  id: string;
  type: string;
  granted_at: string;
  expires_at: string;
  status: string;
  source: string;
};

export type SweepStakeRarity =
  | "common"
  | "uncommon"
  | "rare"
  | "epic"
  | "legendary"; // TODO these are placeholder

export enum SweepStakeRewardTypes {
  POINT = "point",
  SWEEPSTAKE_TICKET = "sweepstake_ticket",
  SWEEPSTAKE_FREE_ENTRY = "sweepstake_free_entry",
  SWEEPSTAKE_TICKET_UPGRADE = "sweepstake_ticket_upgrade",
  EXPERIENCE = "experience",
  TOKEN = "token",
}

interface BaseSweepStakeReward {
  type: SweepStakeRewardTypes;
  metadata: Record<string, string | number>;
}

interface SweepStakePointReward extends BaseSweepStakeReward {
  type: SweepStakeRewardTypes.POINT;
  metadata: {
    amount: number;
  };
}

interface SweepStakeTicketReward extends BaseSweepStakeReward {
  type: SweepStakeRewardTypes.SWEEPSTAKE_TICKET;
  metadata: {
    rarity: string;
  };
}

interface SweepStakeFreeEntryReward extends BaseSweepStakeReward {
  type: SweepStakeRewardTypes.SWEEPSTAKE_FREE_ENTRY;
  metadata: {
    expires_at: string; // ISO date string
  };
}

interface SweepstakeTicketUpgrade extends BaseSweepStakeReward {
  type: SweepStakeRewardTypes.SWEEPSTAKE_TICKET_UPGRADE;
  metadata: {
    expires_at: string; // ISO date string
  };
}

interface SweepStakeExperienceReward extends BaseSweepStakeReward {
  type: SweepStakeRewardTypes.EXPERIENCE;
  metadata: {
    amount: number;
  };
}

interface SweepStakeTokenReward extends BaseSweepStakeReward {
  type: SweepStakeRewardTypes.TOKEN;
  metadata: {
    amount: string; // decimals
    token_address: string;
    token_type: string;
  };
}

export type SweepStakeReward =
  | SweepStakePointReward
  | SweepStakeTicketReward
  | SweepStakeExperienceReward
  | SweepStakeFreeEntryReward
  | SweepstakeTicketUpgrade
  | SweepStakeTokenReward;

export type SweepStakePrize = {
  rewards: SweepStakeReward[];
  jackpotRewards: SweepStakeReward[];
};

export type JackpotWinner = {
  walletAddress: string;
  amount: string;
  hasClaimed: boolean;
};

export type JackpotWinners = Record<string, JackpotWinner[]>;

export type MythicRewardResult = {
  walletAddress: string;
  amount: string;
  claimed: boolean;
};

export type GroupedMythicReward = {
  startDate: string;
  endDate: string;
  questExternalID?: string;
  results: MythicRewardResult[][];
};

export type MythicReward = {
  startDate: string;
  endDate: string;
  questExternalID?: string;
  results: MythicRewardResult[];
};
export type MythicRewards = Record<string, MythicReward>;

export type UserProfile = {
  kyc_status: "pending" | "approved" | "rejected";
};
